<template>
  <div
    class="s-loader"
    :class="{ '-small': small }"
    :style="{ ...spinnerStyle, '--spinner-color': colorValue }" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  small: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '', // fallback to SCSS default if not provided
  },
})
const spinnerStyle = computed(() => {
  if (props.small) {
    return {}
  }

  const dimension = typeof props.size === 'number' ? `${props.size}px` : props.size

  return {
    width: dimension,
    height: dimension,
  }
})
const colorValue = computed(() => props.color || 'var(--color-primary, #007bff)')
</script>

<style lang="scss" scoped>
@import '@/assets/scss/config';
.s-loader {
  width: 24px;
  height: 24px;
  border: 4px solid $color-dark;
  border-bottom-color: transparent;
  box-shadow: 0 0 20px 5px rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border: 4px solid #0000;
  border-right-color: var(--spinner-color, $color-primary);
  position: relative;
  animation: l24 1s infinite linear;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  &.-small {
    width: 12px;
    height: 12px;
    border-width: 2px;
    box-shadow: 0 0 10px 2px rgba(255, 255, 255, 0.6);
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
